import { z } from "zod";
import { RoleFeeKindSchema } from "./assignments";

export const RoleFeeConfigSchema = z.object({
  id: z.string(),
  roleFeeKind: RoleFeeKindSchema,
  showBaseAmount: z.number().int().min(0),
  additionalShowPercent: z.number().int().min(0).max(1000),
  rehearsalDayAmount: z.number().int().min(0),
  multiShowRehearsalPercent: z.number().int().min(0).max(1000),
  status: z.enum(["active", "inactive"]),
  effectiveFrom: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type RoleFeeConfigDTO = z.infer<typeof RoleFeeConfigSchema>;

export const UpdateRoleFeeConfigSchema = z.object({
  showBaseAmount: z.coerce.number().int().min(0),
  additionalShowPercent: z.coerce.number().int().min(0).max(1000),
  rehearsalDayAmount: z.coerce.number().int().min(0),
  multiShowRehearsalPercent: z.coerce.number().int().min(0).max(1000),
  status: z.enum(["active", "inactive"]).default("active"),
});
export type UpdateRoleFeeConfigDTO = z.infer<typeof UpdateRoleFeeConfigSchema>;
